<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          crud-name="Logs de Atividade"
          :table="activityLogsTable"
          :columns="columns"
          :options="options"
          :custom-filters="customFilters"
          :end-point="endPoint"
          :extra="extra"
          :enable-add="false"
          :enable-edit="false"
          :enable-delete="false"
          :enable-view="false"
          :data-form="dataForm"
          @setDateFilter="setDateFilter"
          @details="openDetails"
        />
      </div>
    </div>

    <b-modal
      ref="detailsModal"
      title="Detalhes do registro"
      size="lg"
      hide-footer
    >
      <div v-if="selected">
        <table class="table table-sm table-bordered">
          <tbody>
            <tr><th style="width: 200px">
              Data/Hora
            </th><td>{{ formatDate(selected.created_at) }}</td></tr>
            <tr><th>Usuário</th><td>{{ userName(selected) }} <span v-if="selected.user_id">(ID {{ selected.user_id }})</span></td></tr>
            <tr><th>Evento</th><td>{{ selected.event }}</td></tr>
            <tr><th>Método</th><td>{{ selected.method }}</td></tr>
            <tr><th>Ação / Tela</th><td>{{ selected.action }}</td></tr>
            <tr><th>Rota</th><td>{{ selected.path }}</td></tr>
            <tr><th>Status</th><td>{{ selected.status_code }}</td></tr>
            <tr><th>IP</th><td>{{ selected.ip_address }}</td></tr>
            <tr v-if="selected.subject_name">
              <th>Nome do alvo</th><td>{{ selected.subject_name }}</td>
            </tr>
            <tr v-if="selected.subject_type">
              <th>Tipo do alvo</th><td>{{ subjectLabel(selected) }}</td>
            </tr>
            <tr v-if="selected.subject_user_id">
              <th>Usuário do alvo</th><td>ID {{ selected.subject_user_id }}</td>
            </tr>
            <tr v-if="selected.subject_created_at">
              <th>Criado/horário do alvo</th><td>{{ formatDate(selected.subject_created_at) }}</td>
            </tr>
            <tr><th>Navegador</th><td>{{ selected.user_agent }}</td></tr>
          </tbody>
        </table>

        <h5 class="mt-3">
          Parâmetros
        </h5>
        <pre class="json-box">{{ pretty(selected.route_params) }}</pre>

        <h5 class="mt-3">
          Dados enviados (payload)
        </h5>
        <pre class="json-box">{{ pretty(selected.payload) }}</pre>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

function format(datetime) {
  // created_at é gravado em horário local (America/Sao_Paulo), igual ao resto
  // do sistema — exibe como está, sem reconversão.
  return datetime ? moment(datetime).format('DD/MM/YYYY HH:mm:ss') : 'N/A'
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      activityLogsTable: 'activityLogsTable',
      dateFilter: '',
      selected: null,
      customFilters: [
        {
          name: 'created_at',
          call: 'setDateFilter',
          type: 'calendar',
        },
      ],
      extra: [
        {
          id: 'details',
          name: 'details',
          title: 'Detalhes',
          label: '',
          class: 'btn btn-crud view',
          icon: 'fas fa-eye',
        },
      ],
      columns: [
        'created_at',
        'user_id',
        'method',
        'action',
        'ip_address',
        'status_code',
        'actions',
      ],
      tableData: [
        'created_at',
        'user_id',
        'method',
        'action',
        'ip_address',
        'status_code',
      ],
      options: {
        filterByColumn: true,
        filterable: ['user_id', 'method', 'action'],
        sortable: ['created_at', 'method', 'status_code'],
        orderBy: { column: 'created_at', ascending: false },
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 25,
        perPageValues: [10, 25, 50, 100],
        texts: {
          filterPlaceholder: 'Pesquisar',
        },
        headings: {
          created_at: 'Data/Hora',
          user_id: 'Usuário',
          method: 'Método',
          action: 'Ação / Tela',
          ip_address: 'IP',
          status_code: 'Status',
          actions: 'Detalhes',
        },
        requestFunction(data) {
          const requestData = {}
          const queryString = this.$parent.$parent.$parent.query(data.query)

          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = ['user']

          return axios.get(`${this.url}?${queryString}`, requestData).catch(
            error => {
              this.dispatch('error', error)
            },
          )
        },
        templates: {
          created_at(createElement, rowData) {
            return format(rowData.created_at)
          },
          user_id(createElement, rowData) {
            if (rowData && rowData.user && rowData.user.name) {
              return rowData.user.name
            }
            return rowData && rowData.user_name ? rowData.user_name : 'N/A'
          },
          action(createElement, rowData) {
            const a = rowData && rowData.action ? rowData.action : ''
            // Mostra só Controller@metodo, sem o namespace completo.
            return a.replace('App\\Http\\Controllers\\Api\\', '')
          },
        },
      },
      endPoint: 'activity-logs/',
      dataForm: {},
    }
  },
  methods: {
    setDateFilter(value) {
      this.dateFilter = value || ''
    },
    openDetails(payload) {
      this.selected = payload && payload.row ? payload.row : null
      this.$refs.detailsModal.show()
    },
    formatDate(value) {
      return format(value)
    },
    userName(row) {
      if (row && row.user && row.user.name) return row.user.name
      return row && row.user_name ? row.user_name : 'N/A'
    },
    subjectLabel(row) {
      const type = (row.subject_type || '').split('\\').pop()
      return type + (row.subject_id ? ` #${row.subject_id}` : '')
    },
    pretty(value) {
      if (value === null || value === undefined) return '—'
      try {
        return JSON.stringify(value, null, 2)
      } catch (e) {
        return String(value)
      }
    },
    query(queryFilters) {
      const columns = {
        user_id: 'user_name',
        method: 'method',
        action: 'action',
      }

      let filters = ''

      if (this.dateFilter) {
        // Filtra o dia selecionado (BaseService trata "coluna=de,ate" como intervalo de data).
        const day = encodeURIComponent(this.dateFilter)
        filters += `created_at=${day},${day}&`
      }

      $.each(queryFilters, (index, value) => {
        if (columns[index] && value !== null && value !== undefined && value !== '') {
          filters += `${columns[index]}=${encodeURIComponent(value)}&`
        }
      })

      return filters
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.json-box {
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px;
  max-height: 300px;
  overflow: auto;
  font-size: 12px;
}
</style>
